import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';

import { Text } from '@atlaskit/primitives/compiled';

import type { UpdateWorkItemFieldsAction } from '../../../../../common/types';

import type { priorityField_updateWorkItemFieldsActionRenderer$key } from './__generated__/priorityField_updateWorkItemFieldsActionRenderer.graphql';

const messages = defineMessages({
	action: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.priority-field.action',
		defaultMessage: 'Set priority to {value}',
		description: 'Label for the change action in the priority field',
	},
	setPriority: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.priority-field.setPriority',
		defaultMessage: 'Set priority from {originalValue} to {value}',
		description: 'Label for the set priority in the priority field',
	},
});

export type Props = {
	queryRef: priorityField_updateWorkItemFieldsActionRenderer$key;
	action: UpdateWorkItemFieldsAction;
};

export const PriorityField = ({ queryRef, action }: Props): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const data = useFragment(
		graphql`
			fragment priorityField_updateWorkItemFieldsActionRenderer on JiraPriorityField {
				fieldId
				priority {
					name
				}
			}
		`,
		queryRef,
	);

	if (!data?.fieldId || data?.fieldId !== action.data.fieldKey) {
		return null;
	}

	const value = String(action.data.fieldValue ?? '').trim();

	return (
		<Text
			color="color.text.subtle"
			maxLines={1}
			testId="update-work-item-fields-action-renderer.ui.action-card.card-fields-list.priority-field"
		>
			{data?.priority?.name
				? formatMessage(messages.setPriority, { originalValue: data?.priority?.name, value })
				: formatMessage(messages.action, { value })}
		</Text>
	);
};
